import { Box, IconButton, useBreakpointValue } from '@chakra-ui/react';
import { Modal } from '@time-line/components/common';
import { MagnifyingGlass } from '@time-line/components/icons';
import type { ChangeEvent } from 'react';
import { useEffect, useState } from 'react';

import { SearchResults } from '../SearchResults';
import { SearchHeader } from './SearchHeader';

export function SiteSearchDesktop() {
  const [searchTerm, setSearchTerm] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  useEffect(() => {
    if (!isDesktop) {
      setIsOpen(false);
    }
  }, [isDesktop]);

  const inputProps = {
    placeholder: 'Search',
    value: searchTerm,
    onChange: (e: ChangeEvent<HTMLInputElement>) =>
      setSearchTerm(e.target.value),
  };

  const inputHasValue = inputProps.value !== '';

  const handleNavigate = () => {
    setIsOpen(false);
    setSearchTerm('');
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!isDesktop) {
        return;
      }
      if (
        (e.metaKey || e.ctrlKey) &&
        e.key.toLowerCase() === 'k' &&
        !e.shiftKey &&
        !e.altKey
      ) {
        e.preventDefault();
        setIsOpen(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isDesktop]);

  return (
    <>
      <IconButton
        display={{ base: 'none', lg: 'block' }}
        icon={<MagnifyingGlass width="sm!important" />}
        variant="link"
        aria-label="Search"
        color="currentColor"
        onClick={() => setIsOpen(true)}
      />
      <Modal
        isHeaderVisible={false}
        innerProps={{
          sx: {
            '> div': {
              py: 0,
              px: 0,
              minWidth: '590px',
              borderRadius: '2xl',
            },
          },
        }}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <SearchHeader inputProps={inputProps} isBorderVisible={inputHasValue} />
        {inputHasValue && (
          <Box maxHeight="calc(100vh - 180px)" px="sm" overflowY="auto">
            <SearchResults
              handleClose={handleNavigate}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          </Box>
        )}
      </Modal>
    </>
  );
}
